import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TipsAndUpdatesRoundedIcon from '@mui/icons-material/TipsAndUpdatesRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import CommonButton from '@src/new-components/Button';
import CreditIntro from '@src/containers/CreditIntro';
import NewActionsHeader from '@src/containers/Layout/NewActionsHeader';
import NewPackageInfoV3 from '@src/containers/Layout/SidebarNew/NewPackageInfoV3';
import { NEW_ACTIONS_HEADER_MENU } from '@src/constants';
import ROUTES from '@src/constants/route';
import actions from '@src/redux/actions';
import { useTranslation } from 'react-i18next';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import { StyledHeaderPricing } from './index.style';

const HeaderPricing = ({
  onOpenSubscriptionSuggestion,
  newPricingOverviewEnabled,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { getFeatureValue } = useFeatureFlags();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { user } = useSelector((state) => state.auth);

  const creditIntroConfig = getFeatureValue(FEATURE_KEYS.CREDITS_INTRO, {
    userId: user.id,
    email: user.email,
  });
  const creditIntroEnabled =
    creditIntroConfig !== undefined &&
    Object.hasOwn(creditIntroConfig, 'releaseDate');
  const isCreditIntroMobile = creditIntroEnabled && isMobile;

  const renderCreditIntroButton = () => (
    <CreditIntro isMobile={isCreditIntroMobile} />
  );

  // Desktop shares the header of the other pages; "find your plan" floats on the page instead.
  const renderDesktopActions = () => (
    <>
      <NewActionsHeader
        menuShow={[
          NEW_ACTIONS_HEADER_MENU.TASK_CREDIT,
          NEW_ACTIONS_HEADER_MENU.GUIDE_CREDIT,
          NEW_ACTIONS_HEADER_MENU.LEADERBOARD_VOICE,
          NEW_ACTIONS_HEADER_MENU.NOTIFICATION,
        ]}
        onTaskCredits={() =>
          dispatch(actions.layout.setShowOnboardingPopup(true))
        }
        onLeaderboardVoice={() => history.push(ROUTES.VOICE_LEADERBOARD)}
        margin="0px"
      />
      <NewPackageInfoV3 />
    </>
  );

  const getButtonPadding = () => {
    if (isCreditIntroMobile) return '8px';
    return newPricingOverviewEnabled ? '8px 16px' : '8px 12px';
  };

  return (
    <StyledHeaderPricing isNewOverview={newPricingOverviewEnabled}>
      {newPricingOverviewEnabled ? (
        <div className="project-info">
          <Typography
            variant={isMobile ? 'heading-32-bold' : 'body-20-bold'}
            color="#1c1c1e"
          >
            {t('pricingV2')}
          </Typography>
        </div>
      ) : (
        <div>
          <Typography
            className="title-pricing-model"
            variant="body-20-bold"
            color={COLOR.descriptionGray}
          >
            {t('pricing')}
          </Typography>
        </div>
      )}
      <div className="btn-action">
        {isMobile ? renderCreditIntroButton() : renderDesktopActions()}
        {isMobile && (
          <CommonButton
            startIcon={
              <TipsAndUpdatesRoundedIcon
                sx={{ fontSize: 24, color: COLOR.navyBlue }}
              />
            }
            endIcon={
              <KeyboardArrowRightRoundedIcon
                sx={{ fontSize: 24, color: COLOR.navyBlue }}
              />
            }
            customStyle={{
              border: newPricingOverviewEnabled
                ? '1px solid rgba(30, 22, 78, 0.16)'
                : '1px solid #1E164E29',
              padding: getButtonPadding(),
              borderRadius: '8px',
              height: '40px',
              width: isCreditIntroMobile ? '166.5px' : '181px',
              ...(newPricingOverviewEnabled && { backgroundColor: '#ffffff' }),
            }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.darkBlue,
            }}
            variant="outlineSmall"
            onClick={onOpenSubscriptionSuggestion}
          >
            {t('findYourPlan')}
          </CommonButton>
        )}
      </div>
    </StyledHeaderPricing>
  );
};

export default HeaderPricing;
